import { render, staticRenderFns } from "./TeacherChatMessage.vue?vue&type=template&id=4f16241e&scoped=true"
import script from "./TeacherChatMessage.vue?vue&type=script&lang=ts"
export * from "./TeacherChatMessage.vue?vue&type=script&lang=ts"
import style0 from "./TeacherChatMessage.vue?vue&type=style&index=0&id=4f16241e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f16241e",
  null
  
)

export default component.exports
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerDots});
